import "./../src/js/shims/expose-globals.js";

// utils
import "./../src/js/utils/DOMUtils.js";

// modules
import "./../src/js/modules/AnimationConfig.js";
import "./../src/js/modules/AnimationController.js";
import "./../src/js/modules/AudioAnalyzer.js";
import "./../src/js/modules/AuthController.js";
import "./../src/js/modules/BioController.js";
import "./../src/js/modules/BioDataManager.js";
import "./../src/js/modules/BioGallery.js";
import "./../src/js/modules/BioImageModal.js";
import "./../src/js/modules/BioSectionCollapse.js";
import "./../src/js/modules/BlinkController.js";
import "./../src/js/modules/ProblemTemplates.js";
import "./../src/js/modules/TutorStageController.js";
import "./../src/js/modules/CameraAnimator.js";
import "./../src/js/modules/characterData.js";
import "./../src/js/modules/CharacterFieldOrganizer.js";
import "./../src/js/modules/CharacterSelector.js";
import "./../src/js/modules/ChatController.js";
import "./../src/js/modules/ChatHistoryManager.js";
import "./../src/js/modules/ChatPositionManager.js";
import "./../src/js/modules/ChatStorageManager.js";
import "./../src/js/modules/DirectImageDisplay.js";
import "./../src/js/modules/ElevenLabsTTS.js";
import "./../src/js/modules/A2FEmotionRenderer.js";
import "./../src/js/modules/EpubReaderController.js";
import "./../src/js/modules/EyeTrackingController.js";
import "./../src/js/modules/FirstTimeUserPrompt.js";
import "./../src/js/modules/GreetingService.js";
import "./../src/js/modules/HistoricalFigureImageLibrary.js";
import "./../src/js/modules/ImageFrame3D.js";
import "./../src/js/modules/ImageGalleryController.js";
import "./../src/js/modules/ImagePanel3D.js";
import "./../src/js/modules/ImageViewerModal.js";
import "./../src/js/modules/KeywordImageDisplay.js";
import "./../src/js/modules/LipSyncController.js";
import "./../src/js/modules/LipSyncController.minimal.js";
import "./../src/js/modules/ModelManager.js";
import "./../src/js/modules/ModelPlatformConfig.js";
import "./../src/js/modules/ModelViewer.js";
import "./../src/js/modules/MouthMaterialManager.js";
import "./../src/js/modules/ParticleSystem.js";
import "./../src/js/modules/PBRMaterialManager.js";
import "./../src/js/modules/PlatformHeightController.js";
import "./../src/js/modules/PlatformTestInterface.js";
import "./../src/js/modules/RangeBasedFBXLoader.js";
import "./../src/js/modules/RealTimeLipSyncTap.js";
import "./../src/js/modules/RealtimeLLMToElevenLabs.js";
import "./../src/js/modules/RealtimeTTSController.js";
import "./../src/js/modules/SimpleImagePanel.js";
import "./../src/js/modules/SkyDome.js";
import "./../src/js/modules/SpeakingGlyph.js";
import "./../src/js/modules/StoryData.js";
import "./../src/js/modules/StoryShowcaseController.js";
import "./../src/js/modules/StreamingTTSManager.js";
import "./../src/js/modules/TeethMaterialManager.js";
import "./../src/js/modules/TextureUpdater.js";
import "./../src/js/modules/TimelineData.js";
import "./../src/js/modules/TimelineEventManager.js";
import "./../src/js/modules/TimelineUI.js";
import "./../src/js/modules/TTSControls.existing-ui.js";
import "./../src/js/modules/TTSSelfContainedUI.js";
import "./../src/js/modules/vad-lite.js";
import "./../src/js/modules/VideoController.js";
import "./../src/js/modules/VolumeController.js";
import "./../src/js/modules/QuestionCounterManager.js";
import "./../src/js/modules/historian.js";

// scripts
import "./../src/js/scripts/mouthMaterialControl.js";
import "./../src/js/scripts/teethMaterialControl.js";

// examples
import "./../src/js/examples/real-time-lipsync-example.js";
import "./../src/js/examples/realtime-lipsync-integration.js";

// root
import "./../src/js/aec-test.js";
import "./../src/js/bio-gallery.js";
import "./../src/js/BlendShapeMapper.js";
import "./../src/js/chunked-audio-player.js";
import "./../src/js/chunked-chat-integration.js";

import "./../src/js/HairShaderMaterial.js";
import "./../src/js/historical-figures-app.js";
import "./../src/js/legend-explorer.js";
import "./../src/js/main.js";
import "./../src/js/mic-assistant.js";
//import "./../src/js/mic-permission-test.js";
import "./../src/js/ModelController.js";
import "./../src/js/streaming-chat.js";
import "./../src/js/streaming-real-time.js";

import "./../src/js/TTSManager.js";

// Additional app scripts
import "./../js/firebase-auth-handler.js";
import "./../js/global-auth.js";
